<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Cấu hình mẫu hợp đồng điện tử</h4>
          </div>
        </div>

        <div class="main-body">
          <div class="main-body-search">
            <el-form
              ref="searchForm"
              :model="tableRules.dataSearch.value"
              label-position="left"
              label-width="120px"
              @submit.native.prevent
            >
              <b-row class="align-items-start">
                <b-col md="4">
                  <el-form-item label="Từ khóa">
                    <el-input
                      v-model="tableRules.dataSearch.value.keyword"
                      clearable
                      placeholder="Tìm theo tên mẫu, file mẫu, nội dung"
                      @keyup.enter.native="tableSearch"
                      @clear="tableSearch"
                    />
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Phân loại mẫu">
                    <el-select
                      v-model="tableRules.dataSearch.value.dda_category_id"
                      clearable
                      filterable
                      placeholder="Tất cả"
                      class="w-100"
                      @change="tableSearch"
                    >
                      <el-option
                        v-for="item in dataDefault.categories"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="4" class="search-actions">
                  <el-button round class="btn-default" native-type="submit" @click="tableSearch">
                    Tìm kiếm
                  </el-button>
                  <el-button round class="btn-default" @click="handleManageCategories">
                    Quản lý loại mẫu
                  </el-button>
                  <el-button round class="btn-default" @click="handleCreate">
                    Thêm mới
                  </el-button>
                </b-col>
              </b-row>
            </el-form>
          </div>

          <div class="main-body__table mt-3">
            <el-table :data="tableRules.data" border style="width: 100%" max-height="520">
              <el-table-column label="STT" width="60">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="Tên mẫu" min-width="240" />
              <el-table-column label="Phân loại mẫu" min-width="180">
                <template slot-scope="scope">
                  {{ categoryMap[scope.row.dda_category_id] || "" }}
                </template>
              </el-table-column>
              <el-table-column label="Nội dung" min-width="320">
                <template slot-scope="scope">
                  <span class="content-summary">{{ getContentSummary(scope.row.content) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" width="130" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" plain round type="primary" @click="handleUpdate(scope.row.id)">
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button size="mini" plain round type="danger" @click="handleDelete(scope.row.id)">
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <b-row class="mt-2">
              <b-col md="12" class="text-right">
                <el-pagination
                  @size-change="onSizeChange"
                  @current-change="onCurrentChange"
                  :page-sizes="tableRules.lengthMenu"
                  :page-size="tableRules.limit"
                  :current-page="tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="tableRules.total"
                  :pager-count="5"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="viewMode === 'create' ? 'Thêm mới cấu hình mẫu hợp đồng' : 'Cập nhật cấu hình mẫu hợp đồng'"
      :visible.sync="visibleDialog"
      top="40px"
      width="900px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="form-dialog"
    >
      <el-form
        ref="templateForm"
        :model="dataForm"
        :rules="validForm"
        label-position="left"
        label-width="160px"
        @submit.native.prevent
      >
        <b-row>
          <b-col md="6">
            <el-form-item label="Tên mẫu" prop="name">
              <el-input v-model="dataForm.name" clearable @change="trimField('name')" />
            </el-form-item>
          </b-col>
          <b-col md="6">
            <el-form-item label="Phân loại mẫu" prop="dda_category_id">
              <el-select v-model="dataForm.dda_category_id" clearable filterable class="w-100">
                <el-option
                  v-for="item in dataDefault.categories"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </b-col>
          <b-col md="12">
            <el-form-item label="File mẫu" prop="template_file_id">
              <el-upload
                class="template-upload"
                drag
                action=""
                :auto-upload="false"
                :limit="1"
                :accept="dataDefault.templateFileAccept"
                :file-list="templateFileList"
                :on-change="handleTemplateFileChange"
                :on-remove="handleTemplateFileRemove"
                :on-exceed="handleTemplateFileExceed"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Thả file vào đây hoặc <em>click để upload</em></div>
                <div class="el-upload__tip" slot="tip">
                  Chỉ chọn 1 file mẫu, hỗ trợ doc, docx, pdf, html.
                </div>
              </el-upload>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button class="btn-back" @click="handleClose">Bỏ qua</el-button>
        <el-button type="primary" @click="submitForm">
          {{ viewMode === "create" ? "Thêm mới" : "Cập nhật" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "@/service/LanguageService";
import MethodService from "@/service/MethodService";
import ValidService from "@/service/ValidService";
import ContractTemplateCategoryApi from "@/moduleApi/ContractTemplateCategoryApi";
import ContractTemplateConfigApi from "@/moduleApi/ContractTemplateConfigApi";
import ExtensionService from "@/service/ExtensionService";
import mammoth from "mammoth";
import * as PDFJS from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

const emptyForm = {
  id: null,
  name: "",
  code: "",
  dda_category_id: null,
  template_file_id: null,
  template_file: null,
  content: {
    header: "",
    body: "",
    footer: "",
  },
  config: {
    margin_top: 20,
    margin_bottom: 20,
    margin_left: 30,
    margin_right: 20,
    page_size: "A4",
    page_orientation: "Portrait",
  },
  disabled: false,
};

const emptyTableRules = {
  data: [],
  lengthMenu: [20, 40, 80, 120, 200, 500],
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  dataSearch: {
    value: {
      keyword: "",
      dda_category_id: null,
    },
  },
};

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      visibleDialog: false,
      viewMode: "create",
      dataForm: this.getEmptyForm(),
      templateFileList: [],
      tableRules: MethodService.copyObject(emptyTableRules),
      dataDefault: {
        categories: [],
        templateFileAccept: ".doc,.docx,.pdf,.html,.htm",
      },
      validForm: {
        name: [ValidService.required, ValidService.checkSpaceString, ValidService.checkMaxLength(255)],
        code: [ValidService.required, ValidService.checkSpaceString, ValidService.checkMaxLength(50)],
        dda_category_id: [ValidService.requiredChange],
        template_file_id: [ValidService.requiredChange],
      },
      editorConfig: {
        height: 400,
        contentsCss: [
          "https://cdn.ckeditor.com/4.16.2/full-all/contents.css",
        ],
        toolbar: [
          { name: "document", items: ["Source", "-", "NewPage", "Preview", "Print", "-", "Templates"] },
          { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
          { name: "editing", items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"] },
          "/",
          { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "CopyFormatting", "RemoveFormat"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote", "CreateDiv", "-", "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock", "-", "BidiLtr", "BidiRtl"] },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          { name: "insert", items: ["Image", "Table", "HorizontalRule", "Smiley", "SpecialChar", "PageBreak", "Iframe"] },
          "/",
          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] },
        ],
        removeButtons: "About",
        removePlugins: "exportpdf",
      },
      editorConfigMini: {
        height: 120,
        toolbar: [
          { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "-", "RemoveFormat"] },
          { name: "paragraph", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "styles", items: ["FontSize"] },
        ],
        removePlugins: "exportpdf",
      },
    };
  },
  computed: {
    categoryMap() {
      return this.dataDefault.categories.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
    },
  },
  methods: {
    getEmptyForm() {
      return MethodService.copyObject(emptyForm);
    },
    async loadCategories() {
      const res = await ContractTemplateCategoryApi.list({ limit: 1000 });
      this.dataDefault.categories = res.result || [];
    },
    async initTable() {
      const dataFilter = {
        keyword: this.tableRules.dataSearch.value.keyword,
        dda_category_id: this.tableRules.dataSearch.value.dda_category_id,
        limit: this.tableRules.limit,
        offset: this.tableRules.offset,
      };
      const res = await ContractTemplateConfigApi.list(dataFilter);
      this.tableRules.total = res.meta.total;
      this.tableRules.data = res.result || [];
    },
    tableSearch() {
      if (this.tableRules.dataSearch.value.keyword) {
        this.tableRules.dataSearch.value.keyword = this.tableRules.dataSearch.value.keyword.trim();
      }
      this.tableRules.offset = 0;
      this.tableRules.page = 1;
      this.initTable();
    },
    onSizeChange(limit) {
      this.tableRules.limit = limit;
      this.tableRules.page = 1;
      this.tableRules.offset = 0;
      this.initTable();
    },
    onCurrentChange(page) {
      this.tableRules.page = page;
      this.tableRules.offset = (page - 1) * this.tableRules.limit;
      this.initTable();
    },
    handleCreate() {
      this.viewMode = "create";
      this.dataForm = this.getEmptyForm();
      this.templateFileList = [];
      this.visibleDialog = true;
    },
    handleManageCategories() {
      this.$router.push({ name: "Admin-DocumentDrafting-category-list" }).catch(() => {});
    },
    async handleUpdate(id) {
      const res = await ContractTemplateConfigApi.findById(id);
      if (!res.result) return;
      this.viewMode = "update";
      this.dataForm = {
        ...this.getEmptyForm(),
        ...res.result,
        content: {
          ...this.getEmptyForm().content,
          ...(res.result.content || {}),
        },
      };
      this.templateFileList = this.dataForm.template_file
        ? [
            {
              name: this.dataForm.template_file.name,
              id: this.dataForm.template_file.id,
              url: this.dataForm.template_file.url,
            },
          ]
        : [];
      this.visibleDialog = true;
    },
    handleDelete(id) {
      this.$confirm(this.aLang.c_deleteConfirm, {
        confirmButtonText: this.aLang.c_agree,
        cancelButtonText: this.aLang.c_cancel,
        type: "warning",
      }).then(async () => {
        await ContractTemplateConfigApi.delete(id);
        window.toastr.success("Xóa thành công");
        this.initTable();
      }).catch(() => {});
    },
    trimField(field) {
      if (this.dataForm[field]) this.dataForm[field] = this.dataForm[field].trim();
    },
    getFileExtension(fileName) {
      const parts = String(fileName || "").split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "";
    },
    async handleTemplateFileChange(file, fileList) {
      try {
        const res = await ExtensionService.upload(file, "Template_File");
        const fileId = res.result;

        this.dataForm.template_file_id = fileId;
        this.dataForm.template_file = {
          id: fileId,
          name: file.name,
          size: file.size,
          type: file.raw ? file.raw.type : "",
          extension: this.getFileExtension(file.name),
          url: ExtensionService.urlDowloadFile + fileId,
        };

        const nextFileList = fileList && fileList.length ? fileList.slice(-1) : [file];
        this.templateFileList = nextFileList.map((item) => ({
          ...item,
          id: fileId,
          url: ExtensionService.urlDowloadFile + fileId,
        }));

        if (!this.dataForm.name && file.name) {
          this.dataForm.name = file.name.replace(/\.[^/.]+$/, "");
        }

        // Auto scan to HTML
        this.scanFileToHtml(file);

        this.$nextTick(() => {
          if (this.$refs.templateForm) this.$refs.templateForm.validateField("template_file_id");
        });
      } catch (err) {
        console.error("Upload error:", err);
        this.templateFileList = [];
      }
    },
    async scanFileToHtml(file) {
      const extension = this.getFileExtension(file.name);
      if (!file.raw) {
        console.warn("No raw file found");
        return;
      }
      console.log("Scanning file:", file.name, "Extension:", extension);

      try {
        if (extension === "docx") {
          const arrayBuffer = await this.readFileAsArrayBuffer(file.raw);
          const result = await mammoth.convertToHtml({ arrayBuffer });
          this.dataForm.content.body = result.value;
          window.toastr.success("Đã scan nội dung file .docx sang HTML");
        } else if (extension === "pdf") {
          await this.scanPdfToHtml(file);
        } else if (extension === "html" || extension === "htm") {
          const text = await this.readFileAsText(file.raw);
          this.dataForm.content.body = text;
          window.toastr.success("Đã nạp nội dung file HTML");
        }
      } catch (err) {
        console.error("Scan error:", err);
        window.toastr.error("Không thể scan nội dung file này");
      }
    },
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsArrayBuffer(file);
      });
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsText(file);
      });
    },
    async scanPdfToHtml(file) {
      console.log("Starting PDF scan...");
      try {
        PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        const arrayBuffer = await this.readFileAsArrayBuffer(file.raw);
        const loadingTask = PDFJS.getDocument({ data: arrayBuffer });
        const pdf = await loadingTask.promise;
        console.log("PDF loaded, pages:", pdf.numPages);
        
        let fullHtml = "";
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();
          
          let lastX = -1;
          let lastY = -1;
          let lastWidth = 0;
          let pageHtml = "";
          
          for (const item of textContent.items) {
            const x = item.transform[4];
            const y = item.transform[5];
            
            // New line detection
            if (lastY !== -1 && Math.abs(lastY - y) > 5) {
              pageHtml += "<br/>";
            } else if (lastX !== -1) {
              // Same line - check for word spacing
              const gap = x - (lastX + lastWidth);
              // If gap is significant, add a space (usually > 2 units)
              if (gap > 1.5) { 
                pageHtml += " ";
              }
            }
            
            pageHtml += item.str;
            
            lastX = x;
            lastY = y;
            lastWidth = item.width;
          }
          fullHtml += `<div style="margin-bottom: 20px;">${pageHtml}</div>`;
          if (i < pdf.numPages) fullHtml += "<hr/>";
        }
        
        this.dataForm.content.body = `<div>${fullHtml}</div>`;
        console.log("PDF conversion complete");
        window.toastr.success("Đã trích xuất nội dung PDF sang HTML");
      } catch (err) {
        console.error("PDF conversion error:", err);
        throw err;
      }
    },
    onEditorReady(editor) {
      // Optional: handle editor ready event
    },
    handleTemplateFileRemove() {
      this.dataForm.template_file_id = null;
      this.dataForm.template_file = null;
      this.templateFileList = [];
      this.$nextTick(() => {
        if (this.$refs.templateForm) this.$refs.templateForm.validateField("template_file_id");
      });
    },
    handleTemplateFileExceed(files) {
      const file = files && files.length ? files[0] : null;
      if (!file) return;
      this.handleTemplateFileChange({
        name: file.name,
        raw: file,
        size: file.size,
      }, []);
    },
    getContentSummary(content) {
      const body = content && content.body ? content.body : "";
      return body.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    },
    submitForm() {
      this.trimField("name");
      this.$refs.templateForm.validate(async (valid) => {
        if (!valid) return;
        const data = MethodService.copyObject(this.dataForm);
        console.log("Submit request data:", data);

        if (this.viewMode === "create") {
          await ContractTemplateConfigApi.create(data);
          window.toastr.success("Thêm mới thành công");
        } else {
          await ContractTemplateConfigApi.update(data);
          window.toastr.success("Cập nhật thành công");
        }

        this.handleClose();
        this.initTable();
      });
    },
    handleClose() {
      this.visibleDialog = false;
      this.viewMode = "create";
      this.dataForm = this.getEmptyForm();
      this.templateFileList = [];
      if (this.$refs.templateForm) this.$refs.templateForm.resetFields();
    },
  },
  async created() {
    await this.loadCategories();
    await this.initTable();
  },
};
</script>

<style lang="scss" scoped>
.content-summary {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .template-upload .el-upload,
::v-deep .template-upload .el-upload-dragger {
  width: 100%;
}

.search-actions {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 0;

  .el-button + .el-button {
    margin-left: 0;
  }

  .el-button {
    white-space: nowrap;
  }
}

@media (max-width: 767.98px) {
  .search-actions {
    justify-content: flex-start;
    margin-bottom: 16px;
  }
}
</style>
